/* @generated from adl module ferovinum.datacontracts.purchaserequestadditionalcost */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';

export interface PurchaseRequestAdditionalCostRawRecord {
  id: common_strings.StringNE;
  purchaseRequestId: common_strings.StringNE;
  amount: common.BigDecimal;
  description: common_strings.StringNE;
  costType: common_strings.StringNE;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makePurchaseRequestAdditionalCostRawRecord(
  input: {
    id: common_strings.StringNE,
    purchaseRequestId: common_strings.StringNE,
    amount: common.BigDecimal,
    description: common_strings.StringNE,
    costType: common_strings.StringNE,
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): PurchaseRequestAdditionalCostRawRecord {
  return {
    id: input.id,
    purchaseRequestId: input.purchaseRequestId,
    amount: input.amount,
    description: input.description,
    costType: input.costType,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const PurchaseRequestAdditionalCostRawRecord_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.datacontracts.purchaserequestadditionalcost","decl":{"annotations":[{"value":{"datasetName":"raw_purchase_request_additional_cost"},"key":{"moduleName":"ferovinum.datacontracts.common","name":"RawExportDataset"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"purchaseRequestId","default":{"kind":"nothing"},"name":"purchaseRequestId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"amount","default":{"kind":"nothing"},"name":"amount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"costType","default":{"kind":"nothing"},"name":"costType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"PurchaseRequestAdditionalCostRawRecord","version":{"kind":"nothing"}}};

export const snPurchaseRequestAdditionalCostRawRecord: ADL.ScopedName = {moduleName:"ferovinum.datacontracts.purchaserequestadditionalcost", name:"PurchaseRequestAdditionalCostRawRecord"};

export function texprPurchaseRequestAdditionalCostRawRecord(): ADL.ATypeExpr<PurchaseRequestAdditionalCostRawRecord> {
  return {value : {typeRef : {kind: "reference", value : snPurchaseRequestAdditionalCostRawRecord}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.datacontracts.purchaserequestadditionalcost.PurchaseRequestAdditionalCostRawRecord" : PurchaseRequestAdditionalCostRawRecord_AST
};
